/**
 * /settings index — the parent `_auth.settings.tsx` is a layout that only
 * renders <Outlet />, so without an index child /settings rendered blank.
 * Redirect to the user's own profile (always accessible, no admin gate).
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/settings/")({
  beforeLoad: () => {
    throw redirect({ to: "/settings/profile" });
  },
});
